export type SortColumn = {
  column?: string;
  reverse: boolean
}

export function sortUpdate(column: string) {
  return (prev: SortColumn): SortColumn => ({
    column,
    reverse: prev.column === column ? !prev.reverse : false
  });
}
